module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0af4f18c7b16bff354edaf9a66edd265.png";